export default "__VITE_ASSET__DIpPq4rf__"